export interface DefaultFilterItem {
  selected: boolean;
  label: string;
  value: number;
}
